<template>
    <div>
        <div class="vx-row">
            <div class="vx-col md:w-8/12 mt-5">
                <label>Choose Plan <a class="reference-link" target="_blank" href="https://www.chefstein.ai">(View Plans)</a></label>
                <vs-select v-model="selectedPlan" class="w-full select-large" placeholder="Please choose a plan" name="plan">
                    <vs-select-item v-for="item in stripePlans.data" 
                        :key="item.id" 
                        :value="item" 
                        :text="getProductName(item)"
                        :disabled="true"
                        class="w-full" 
                    />
                </vs-select>
            </div>
            <div v-if="update && selectedPlan.id" class="vx-col md:w-1/2 mt-5" >
                <vs-button
                    @click="updateSubscription()"
                    color="primary"
                    type="filled"
                    class="customizer-btn">Upgrade Plan</vs-button>
            </div>
        </div>
    </div>
</template>
<script>
import helperMethods from '../../../mixins/helperMethods'
import { getStripeSubscriptions, updateStripeSubscription } from '../../../stripe/stripeHelperMethods'

export default {
    props: {
        update: Boolean,
        upgradeablePlans: Array
    },
    mixins: [
        helperMethods
    ],
    data () {
        return {
            stripePlans: {},
            selectedPlan: {},
            stripeProducts: [],
            selectedProduct: '',
            stripeSubscriptions: {}
        }
    },
    mounted() {
        this.stripePlans = this.update ? { data: this.upgradeablePlans } : this.$store.state.AppActiveUser.stripePlans
        this.stripeProducts = this.$store.state.AppActiveUser.stripeProducts
        this.stripeSubscriptions = this.$store.state.AppActiveUser.stripeSubscriptions
        this.$store.commit('UPDATE_USER_INFO', { selectedPlan: {} }, {root: true})
    },
    watch: {
        selectedPlan(val) {
            const plan = this.stripePlans.data[this.stripePlans.data.findIndex(plan => plan.id === val.id)]
            this.selectedProduct = this.stripeProducts.data[this.stripeProducts.data.findIndex(product => product.id === plan.product)]
            this.$store.commit('UPDATE_USER_INFO', { selectedPlan: this.selectedPlan, selectedProduct: this.selectedProduct }, {root: true})
        }
    },
    methods: {
        getProductName(plan) {
            const productName = this.stripeProducts.data[this.stripeProducts.data.findIndex(product => product.id === plan.product)].name;
            return productName + ' (' + plan.nickname + ') ' + (plan.amount / 100) + '€'
        },
        updateSubscription() {
            this.$vs.loading()
            // There should not be more than 1 subscription per customer
            const sub = this.stripeSubscriptions.data[0]

            let updateProps = {
                subscription_id: sub.id,
                cancel_at_period_end: false,
                items: [{
                    id: sub.items.data[0].id, // We assume there's only one item per subscription
                    plan: this.selectedPlan.id,
                }]
            }

            updateStripeSubscription(updateProps)
                .then (() => {
                    //console.log('Update subscription POST result:', result)

                    // Refresh the whole subs list
                    getStripeSubscriptions(this.$store.state.AppActiveUser.stripe_id)  
                        .then (result => {
                            //console.log('subscription GET result:', result)
                            this.stripeSubscriptions = (result.data.data && result.data.data.length > 0) ? result.data : {};
                            this.$store.commit('UPDATE_USER_INFO', { stripeSubscriptions: this.stripeSubscriptions, hasSubscriptions: this.hasData(this.stripeSubscriptions) }, { root: true })
                            this.$emit('sub-plan-update', this.stripeSubscriptions)
                            this.$vs.notify({
                                title: 'Plan subscription update',
                                text: 'Updated the selected subscription succesfully',
                                iconPack: 'feather',
                                icon: 'icon-alert-circle',
                                color: 'success'
                            })
                        }).catch(err => {
                            this.hasSubscriptions = false
                            this.$vs.notify({
                                title: 'Plan subscription update',
                                text: 'Error occured while fetching updated subscriptions: ' + err.response.data.raw.message,
                                iconPack: 'feather',
                                icon: 'icon-alert-circle',
                                color: 'danger'
                            })
                        })  
                }).catch(err => {
                    this.hasSubscriptions = false
                    this.subsError = 'Error occured while fetching subscriptions: ' + err.response.data.raw.message
                    this.$vs.notify({
                        title: 'Plan subscription update',
                        text: 'Error occured while fetching subscriptions: ' + err.response.data.raw.message,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    })
                }).finally(() => {
                    this.subsLoading = false
                    this.$vs.loading.close()
                })
        },
    }
}
</script>
<style scoped>
.plans-table th, td {
  text-align: center;
}
.plans-table tr {
    border-bottom: 1px solid #cdcdcd;
}
.reference-link {
    font-size: smaller;
    color: #9e9e9e;
}
</style>